<template>
  <div v-transfer-dom :data-transfer="transfer">
    <transition :name="transitionNames[1]">
      <div
        :class="maskClasses"
        :style="wrapStyles"
        v-show="visible"
        v-if="showMask"
        @click="handleMask"
      ></div>
    </transition>
    <div :class="wrapClasses" :style="wrapStyles" @click="handleWrapClick">
      <transition :name="transitionNames[0]" @after-leave="animationFinish">
        <div :class="classes"  v-show="visible">
          <div
            :class="contentClasses"
            ref="content"
          >
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import TransferDom from "../../directives/transfer-dom";
import Emitter from "../../mixins/emitter";
const prefixCls = "yjui-modal";

export default {
  name: "Modal",
  mixins: [Emitter],
  directives: { TransferDom },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default() {
        return true;
      }
    },
    title: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 520
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default() {
        return {};
      }
    },
    className: {
      type: String
    },
    // for instance
    footerHide: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    transitionNames: {
      type: Array,
      default() {
        return ["ease", "fade"];
      }
    },
    transfer: {
      type: Boolean,
      default() {
        return false;
      }
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      wrapShow: false,
      showHead: true,
      buttonLoading: false,
      visible: this.value
    };
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}-wrap`,
        {
          [`${prefixCls}-hidden`]: !this.wrapShow,
          [`${this.className}`]: !!this.className,
          [`${prefixCls}-no-mask`]: !this.showMask
        }
      ];
    },
    wrapStyles() {
      return {
        zIndex:  this.zIndex
      };
    },
    maskClasses() {
      return `${prefixCls}-mask`;
    },
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-fullscreen`]: this.fullscreen,
          [`${prefixCls}-fullscreen-no-header`]:
            this.fullscreen && !this.showHead,
          [`${prefixCls}-fullscreen-no-footer`]:
            this.fullscreen && this.footerHide
        }
      ];
    },
    contentClasses() {
      return [
        `${prefixCls}-content`,
        {
          [`${prefixCls}-content-no-mask`]: !this.showMask
        }
      ];
    },
    mainStyles() {
      let style = {};

      const width = parseInt(this.width);
      const styleWidth ={
              width: width <= 100 ? `${width}%` : `${width}px`
            }
      

      const customStyle = this.styles ? this.styles : {};

      Object.assign(style, styleWidth, customStyle);

      return style;
    },

    localeOkText() {
      if (this.okText === undefined) {
        return this.t("i.modal.okText");
      } else {
        return this.okText;
      }
    },
    localeCancelText() {
      if (this.cancelText === undefined) {
        return this.t("i.modal.cancelText");
      } else {
        return this.cancelText;
      }
    },
    showMask() {
      return  this.mask;
    }
  },
  methods: {
    handleMask() {
      if (this.maskClosable && this.showMask) {
        this.close();
      }
    },
    handleWrapClick(event) {
      const className = event.target.getAttribute("class");
      if (className && className.indexOf(`${prefixCls}-wrap`) > -1)
        this.handleMask();
    },

    animationFinish() {
      this.$emit("on-hidden");
    },




  },
  mounted() {
  
  }
};
</script>
<style>
.yjui-modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  left: 0;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
}
.yjui-modal-wrap {
  position: fixed;

    width: 85%;

    top: 50%;
    left: 50%;
        transform: translate(-50%,-50%);
}

.yjui-modal-content {
  position: relative;
  background-color: #fff;
  border: 0;
  border-radius: 3px;
  background-clip: padding-box;
  padding: 25px 20px
}
.yjui-modal-head{padding-bottom:10px;}
.yjui-modal-head-title{  text-align: center;   font-weight: 400;font-size: 18px; color: #000;}
.yjui-modal-body{ padding-bottom:20px;
    min-height: 40px;
    font-size: 15px;
    line-height: 1.3;
    word-wrap: break-word;
    word-break: break-all;
    color: #999;text-align: center;}
.yjui-modal-footer{    position: relative;line-height: 48px;font-size: 18px;display: flex; text-align: center; }
.yjui-modal-footer span{display: block;flex: 1;color: #0bb20c;text-decoration: none;-webkit-tap-highlight-color: rgba(0,0,0,0);position: relative; border-radius: 3px;}
.yjui-modal-footer span.btn_default{ background-color: #f2f2f2;   color: #484848;}
.yjui-modal-footer span.btn_primary{ background-image: linear-gradient(to right,#f12711,#f5af19);   color: #fff;}
.yjui-modal-footer span:nth-child(2){margin-left: 15px;}
/* .yjui-modal-footer span:last-child::after{content:" ";position:absolute;left:0;top:0;width:1px;bottom:0;border-left:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleX(.5);transform:scaleX(.5);}
.yjui-modal-footer::after{content:" ";position:absolute;left:0;top:0;right:0;height:1px;border-top:1px solid #d5d5d6;color:#d5d5d6;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleY(.5);transform:scaleY(.5);} */
.ease-enter-active,
.ease-appear {
  opacity: 0;
  animation-name: yjuiEaseIn;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
.ease-leave-active {
  animation-name: yjuiEaseOut;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
@keyframes yjuiEaseIn {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes yjuiEaseOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

.fade-enter-active,
.fade-appear {
  animation-name: yjuiFadeIn;
  opacity: 0;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
.fade-leave-active {
  animation-name: yjuiFadeOut;
  animation-timing-function: linear;
  animation-duration: 0.2s;
}
@keyframes yjuiFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes yjuiFadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modal/modal.vue